import { render, staticRenderFns } from "./DowAgg.vue?vue&type=template&id=72064eca&scoped=true&"
import script from "./DowAgg.vue?vue&type=script&lang=js&"
export * from "./DowAgg.vue?vue&type=script&lang=js&"
import style0 from "./DowAgg.vue?vue&type=style&index=0&id=72064eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72064eca",
  null
  
)

export default component.exports